import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card } from 'reactstrap';
import Table from '../../../common/Table';
import { BANK_RECONCILIATION_LIQUIDATION_SUMMARY_COLUMNS } from '../../../../config/columns';

const BankReconciliationLiquidationCoverageTable = ({
  liquidationSummary,
  loading,
}) => (
  <Card className="shadow-sm border-0 mb-4">
    <div className="px-3 py-2 border-bottom bg-white">
      <span className="font-weight-medium">
        Cobertura de liquidaciones: monto a depositar vs. monto depositado
      </span>
    </div>
    <Table
      columns={BANK_RECONCILIATION_LIQUIDATION_SUMMARY_COLUMNS}
      data={liquidationSummary ? [liquidationSummary] : []}
      loading={loading}
      manual={false}
      showPagination={false}
      pageSize={1}
    />
  </Card>
);

BankReconciliationLiquidationCoverageTable.propTypes = {
  liquidationSummary: PropTypes.shape({
    totalLiquidations: PropTypes.number,
    coveredLiquidations: PropTypes.number,
    incompleteLiquidations: PropTypes.number,
    withoutDepositLiquidations: PropTypes.number,
    amountToDeposit: PropTypes.number,
    amountDeposited: PropTypes.number,
    liquidationDifference: PropTypes.number,
    surplus: PropTypes.number,
  }),
  loading: PropTypes.bool,
};

BankReconciliationLiquidationCoverageTable.defaultProps = {
  liquidationSummary: null,
  loading: false,
};

// Data is fetched by BankReconciliationBankSummaryTable (same endpoint)
const mapStateToProps = ({ SalesUnit }) => ({
  liquidationSummary: SalesUnit.BankReconciliation.getIn([
    'bankSummary',
    'liquidationSummary',
  ]),
  loading: SalesUnit.BankReconciliation.getIn(['bankSummary', 'loading']),
});

export { BankReconciliationLiquidationCoverageTable };
export default connect(mapStateToProps)(
  BankReconciliationLiquidationCoverageTable,
);
